import { useRef } from "react";
import Aside from "../../components/Aside";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import EmailEditor, { EditorRef, EmailEditorProps } from "react-email-editor";

export default function EmailBuilderPage() {
  const emailEditorRef = useRef<EditorRef>(null);

  const exportHtml = () => {
    const unlayer = emailEditorRef.current?.editor;

    unlayer?.exportHtml((data) => {
      const { design, html } = data;
      console.log("exportHtml", html);
    });
  };

  const onReady: EmailEditorProps["onReady"] = (unlayer) => {
    // editor is ready
    // you can load your template here;
    // the design json can be obtained by calling
    // unlayer.loadDesign(callback) or unlayer.exportHtml(callback)
    // const templateJson = { DESIGN JSON GOES HERE };
    // unlayer.loadDesign(templateJson);
  };

  return (
    <>
      <Header>
        <div>
          <h4>Plantillas de correo</h4>
          <p>Administra y crea nuevas plantillas de correo</p>
        </div>

        <div className="ms-auto">
          <div className="dropdown">
            <button
              className="btn btn-primary dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Guardar
            </button>
            <div className="dropdown-menu mt-2">
              {/* <button className="dropdown-item" onClick={() => navigate('/campaigns/form', { state: { type: 'whatsapp' } })}>WhatsApp</button> */}
              {/* <button className="dropdown-item" onClick={() => navigate('/campaigns/form', { state: { type: 'sms' } })}>SMS</button> */}
              {/* <button className="dropdown-item" onClick={() => navigate('/campaigns/form', { state: { type: 'email' } })}>Email</button> */}
            </div>
          </div>
        </div>
      </Header>

      <Aside />

      <main role="main" className="main">
        <div className="content container px-5">
          <EmailEditor ref={emailEditorRef} onReady={onReady} />
        </div>
        <Footer />
      </main>
    </>
  );
}
